import {desktopDto} from '@vectronic/desktop-api'
import {httpDtos} from '@vectronic/openApi-admin'
import {webDtos} from '@vectronic/openApi-customer'
import {_EventHelpGeneric} from './event.help.generic'

export enum _EventTypeGeneric {
  MORTALITY = 'Mortality',
  MORTALITY_IMPLANT = 'MortalityImplant',
  PROXIMITY = 'Proximity',
  SEPARATION = 'Separation',
  TRAP = 'Trap',
  VAGINAL_IMPLANT = 'VaginalImplant',
  VIRTUAL_FENCE = 'VirtualFence',
  POSITION = 'Position',
  ACTIVITY = 'Activity',
  COLLAR_LOG = 'CollarLog',
}

export type _BaseEventGeneric = ReturnType<typeof _EventHelpGeneric.base>[number]
export type _WithPositionEventGeneric = ReturnType<typeof _EventHelpGeneric.all>[number]

export type _EventToWebDtoGeneric<T extends _EventTypeGeneric> = T extends _EventTypeGeneric.ACTIVITY
  ? webDtos.Activity
  : T extends _EventTypeGeneric.MORTALITY
    ? webDtos.Mortality
    : T extends _EventTypeGeneric.MORTALITY_IMPLANT
      ? webDtos.MortalityImplant
      : T extends _EventTypeGeneric.PROXIMITY
        ? webDtos.Proximity
        : T extends _EventTypeGeneric.SEPARATION
          ? webDtos.Separation
          : T extends _EventTypeGeneric.TRAP
            ? webDtos.TrapEvent
            : T extends _EventTypeGeneric.VAGINAL_IMPLANT
              ? webDtos.VaginalImplant
              : T extends _EventTypeGeneric.VIRTUAL_FENCE
                ? webDtos.VirtualFence
                : T extends _EventTypeGeneric.POSITION
                  ? webDtos.GPSPosition
                  : T extends _EventTypeGeneric.COLLAR_LOG
                    ? httpDtos.CollarLog
                    : unknown

export type _EventWebDtoGeneric =
  | webDtos.Activity
  | webDtos.Mortality
  | webDtos.MortalityImplant
  | webDtos.Proximity
  | webDtos.Separation
  | webDtos.TrapEvent
  | webDtos.VaginalImplant
  | webDtos.VirtualFence
  | webDtos.GPSPosition
  | httpDtos.CollarLog

export type _EventRequestDtoGeneric =
  | webDtos.ActivityRequest
  | webDtos.MortalityRequest
  | webDtos.VirtualFenceRequest
  | webDtos.TrapEventRequest
  | webDtos.DataRequest
  | webDtos.PositionRequest

export type _EventToDesktopDtoGeneric<T extends _EventTypeGeneric> = T extends _EventTypeGeneric.ACTIVITY
  ? desktopDto.Activity
  : T extends _EventTypeGeneric.MORTALITY
    ? desktopDto.Mortality
    : T extends _EventTypeGeneric.MORTALITY_IMPLANT
      ? desktopDto.MortalityImplant
      : T extends _EventTypeGeneric.PROXIMITY
        ? desktopDto.Proximity
        : T extends _EventTypeGeneric.SEPARATION
          ? desktopDto.Separation
          : T extends _EventTypeGeneric.TRAP
            ? desktopDto.TrapEvent
            : T extends _EventTypeGeneric.VAGINAL_IMPLANT
              ? desktopDto.VaginalImplant
              : T extends _EventTypeGeneric.VIRTUAL_FENCE
                ? desktopDto.VirtualFence
                : T extends _EventTypeGeneric.POSITION
                  ? desktopDto.Position
                  : T extends _EventTypeGeneric.COLLAR_LOG
                    ? desktopDto.CollarLog
                    : unknown

export type _EventToHttpDtoGeneric<T extends _EventTypeGeneric> = T extends _EventTypeGeneric.ACTIVITY
  ? httpDtos.Activity
  : T extends _EventTypeGeneric.MORTALITY
    ? httpDtos.Mortality
    : T extends _EventTypeGeneric.MORTALITY_IMPLANT
      ? httpDtos.MortalityImplant
      : T extends _EventTypeGeneric.PROXIMITY
        ? httpDtos.Proximity
        : T extends _EventTypeGeneric.SEPARATION
          ? httpDtos.Separation
          : T extends _EventTypeGeneric.TRAP
            ? httpDtos.TrapEvent
            : T extends _EventTypeGeneric.VAGINAL_IMPLANT
              ? httpDtos.VaginalImplant
              : T extends _EventTypeGeneric.VIRTUAL_FENCE
                ? httpDtos.VirtualFence
                : T extends _EventTypeGeneric.POSITION
                  ? httpDtos.GPSPosition
                  : T extends _EventTypeGeneric.COLLAR_LOG
                    ? httpDtos.CollarLog
                    : unknown

export type _EventToRequestDtoGeneric<T extends _EventTypeGeneric> = T extends _EventTypeGeneric.ACTIVITY
  ? webDtos.ActivityRequest
  : T extends _EventTypeGeneric.MORTALITY
    ? webDtos.MortalityRequest
    : T extends
          | _EventTypeGeneric.MORTALITY_IMPLANT
          | _EventTypeGeneric.PROXIMITY
          | _EventTypeGeneric.SEPARATION
          | _EventTypeGeneric.VAGINAL_IMPLANT
          | _EventTypeGeneric.VIRTUAL_FENCE
          | _EventTypeGeneric.COLLAR_LOG
      ? webDtos.DataRequest
      : T extends _EventTypeGeneric.TRAP
        ? webDtos.TrapEventRequest
        : T extends _EventTypeGeneric.POSITION
          ? webDtos.PositionRequest
          : unknown

export type _EventToDesktopRequestDtoGeneric<T extends _EventTypeGeneric> = T extends _EventTypeGeneric.ACTIVITY
  ? desktopDto.ActivityRequest
  : T extends _EventTypeGeneric.COLLAR_LOG
    ? desktopDto.CollarLogRequest
    : T extends _EventTypeGeneric.MORTALITY
      ? desktopDto.MortalityRequest
      : T extends
            | _EventTypeGeneric.MORTALITY_IMPLANT
            | _EventTypeGeneric.PROXIMITY
            | _EventTypeGeneric.SEPARATION
            | _EventTypeGeneric.VAGINAL_IMPLANT
            | _EventTypeGeneric.VIRTUAL_FENCE
        ? desktopDto.DataRequest
        : T extends _EventTypeGeneric.TRAP
          ? desktopDto.TrapRequest
          : T extends _EventTypeGeneric.POSITION
            ? desktopDto.PositionRequest
            : unknown
